<template>
  <div class="manage">
    <div class="banner">
      <img src="@i/manage/banner.png" alt="" />
      <div class="btn-g">
        <!-- <b-button>添加官方微信号</b-button>
        <b-button pill>立即咨询</b-button> -->
      </div>
    </div>
    <des :hasLine="false">
      <template slot="title">
        <span style="color: #323232">智晓慧SaaS智能云平台，让管理更智能</span>
      </template>
      <template slot="des">
        精细化客户服务结合智能化客户管理打造高质量私域流量池
      </template>
    </des>
    <div class="drainage">
      <b-container class="bv-example-row drainage-box">
        <b-row>
          <b-col
            md="3"
            sm="6"
            xs="12"
            v-for="(item, index) in info1"
            :key="index"
          >
            <img :src="item.img" alt="" />
            <div class="drainage-title">{{ item.title }}</div>
            <div class="drainage-des">
              {{ item.des }}
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="operate-center">
      <!-- <des-shout :hasLine="false">
        <template slot="title">
          <span style="color: black">跨平台一站式运营</span>
        </template>
        <template slot="des">
          S智能云平台，横跨抖音、个微、企微、小程序等多个平台，SOP流程化、智能化客户运营方案
        </template>
      </des-shout> -->
      <div class="hot">
        <div class="hot-title">
          <des :hasLine="false">
            <template slot="title">
              <span style="color: #323232">客户SOP智能化管理</span>
            </template>
            <template slot="des">
              Intelligent management of customer SOP
            </template>
          </des>
        </div>
        <b-container class="bv-example-row">
          <b-row align-v="center">
            <b-col md="6" sm="6" xs="12">
              <div class="sort">
                <div class="sort-list">
                  <div class="left">
                    <img
                      style="width: 50px"
                      src="@i/manage/shangpinshengmingzhouqi.png"
                      alt=""
                    />
                  </div>
                  <div class="center">
                    <div style="font-size: 22px; font-weight: bold">
                      客户生命周期管理
                    </div>
                    <div style="font-size: 14px">
                      以客户为中心去设计，帮助客户养成重复购买的习惯。
                    </div>
                  </div>
                </div>
                <div class="sort-list">
                  <div class="left">
                    <img
                      style="width: 50px"
                      src="@i/manage/xiangmu.png"
                      alt=""
                    />
                  </div>
                  <div class="center">
                    <div style="font-size: 22px; font-weight: bold">
                      自定义客户生命周期
                    </div>
                    <div style="font-size: 14px">
                      企业自定义设置客户的发展阶段，并设置好每个阶段的提醒时间。
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col md="6" sm="6" xs="12">
              <div class="mackbook">
                <img src="@i/manage/mackbook1.png" alt="" />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="hot">
        <div class="hot-title">
          <des :hasLine="false">
            <template slot="title">
              <span style="color: #323232">社群SOP智能化管理</span>
            </template>
            <template slot="des">
              Community SOP intelligent management
            </template>
          </des>
        </div>
        <b-container>
          <b-row align-v="center" align-h="between">
            <b-col md="6" sm="6" xs="12">
              <div class="mackbook">
                <img src="@i/manage/mackbook2.png" alt="" />
              </div>
            </b-col>
            <b-col md="6" sm="6" xs="12">
              <div class="sort">
                <div class="sort-list list-right">
                  <div class="left">
                    <img style="width: 50px" src="@i/manage/rili.png" alt="" />
                  </div>
                  <div class="center">
                    <div style="font-size: 22px; font-weight: bold">群日历</div>
                    <div style="font-size: 14px">
                      给对应群添加日历任务，
                      到达指定时间后通知对应的员工去执行对应的任务。
                    </div>
                  </div>
                </div>
                <div class="sort-list list-right">
                  <div class="left">
                    <img
                      style="width: 50px"
                      src="@i/manage/qunsop.png"
                      alt=""
                    />
                  </div>
                  <div class="center">
                    <div style="font-size: 22px; font-weight: bold">群SOP</div>
                    <div style="font-size: 14px">
                      给群制定SOP线性任务，达到条件后通知员工去执行不同的任务。
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="hot">
        <div class="hot-title">
          <des :hasLine="false">
            <template slot="title">
              <span style="color: #323232">客户流失预警</span>
            </template>
            <template slot="des"> Customer churn warning </template>
          </des>
        </div>
        <b-container>
          <b-row align-v="center" align-h="between">
            <b-col md="6" sm="6" xs="12">
              <div class="mackbook">
                <img src="@i/manage/mackbook3.png" alt="" />
              </div>
            </b-col>
            <b-col md="6" sm="6" xs="12">
              <div class="sort">
                <div class="sort-list list-right">
                  <div class="left">
                    <img style="width: 50px" src="@i/manage/shuju.png" alt="" />
                  </div>
                  <div class="center">
                    <div style="font-size: 22px; font-weight: bold">
                      客户流失分析
                    </div>
                    <div style="font-size: 14px">
                      实时查看客户流失情况，不同员工的客户流失率
                      分析流失原因，找到最优留存方式，及时跟进，降低流失率
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <Customer />
  </div>
</template>

<script>
import Des from "@/components/Des";
import Customer from "@/components/Customer";
// import DesShout from "@/components/DesShout";
export default {
  components: {
    des: Des,
    Customer,
    // "des-shout": DesShout,
  },
  data() {
    return {
      info1: [
        {
          img: require("@i/manage/dicengjiagou.png"),
          title: "客户标签分类",
          des: "分析不同渠道不同标签下的客户增长情况，备注不同渠道的行为客户画像标签。",
        },
        {
          img: require("@i/manage/xingnengjisuan.png"),
          title: "客户群体智能分类",
          des: "按照不同意向，状态，价值等客户属性进行自动分类，便于销售跟进。",
        },
        {
          img: require("@i/manage/qunsop.png"),
          title: "客户群管理",
          des: "聚合管理多个客户群，SOP运营流程，提升群活跃。",
        },
        {
          img: require("@i/manage/jilu.png"),
          title: "多维数据记录",
          des: "客户行为记录数据分析，最终以数据结果为导向，为企业微信客服制定KPI。",
        },
      ],
    };
  },
};
</script>

<style scoped>
.t-blue {
  color: #0073f8;
}
.manage .banner {
  position: relative;
}
.manage .banner img {
  width: 100%;
}
.manage .btn-g {
  position: absolute;
  top: 0;
  top: 80%;
  left: 13%;
}
.manage .btn-g button {
  background: #ffffff;
  color: #2f8df9;
  border-radius: 17px;
  border: none;
  font-weight: bold;
}

.manage .btn-g button:last-child {
  margin-left: 10px;
}
.drainage {
  margin: 100px 0;
}
.drainage .drainage-box {
  text-align: center;
  margin-top: 50px;
}
.drainage .drainage-box img {
  width: 50px;
  height: 50px;
}
.drainage .drainage-box .drainage-title {
  font-size: 20px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #323232;
  line-height: 50px;
}
.drainage .drainage-box .drainage-des {
  font-size: 8px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #323232;
  line-height: 20px;
}

.operate-center {
  background: #f5f9ff;
  padding: 50px 0;
}
.hot {
  background: #f9fbff;
  padding: 50px 0;
}

.hot:nth-child(2n + 1) {
  background: white;
}

.hot .hot-title {
  text-align: center;
  margin: 80px 0;
  font-size: 20px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #323232;
  line-height: 19px;
}

.list-box {
  line-height: 80px;
  margin-left: 100px;
}

.mackbook img {
  width: 100%;
}

.list-box .list {
}

.list-box .list .list-title {
  font-size: 25px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #323232;
}

.list-box .list .list-title::before {
  content: url(../../assets/rise/rectangle.png);
  margin-right: 15px;
}

.list-box .list .list-subtitle {
  font-size: 14px;
  font-family: SourceHanSansCN;
  font-weight: 300;
  color: #323232;
  line-height: 17px;
}

.sort .list-right {
  float: right;
}

.sort .sort-list {
  display: flex;
  background: white;
  align-items: center;
  width: 80%;
  padding: 20px 30px;
  box-shadow: 3px 7px 10px 0px rgba(0, 0, 0, 0.05);
}
.sort .left {
  font-size: 30px;
  font-family: DIN;
  font-weight: normal;
  color: black;
  line-height: 55px;
}

.sort .center {
  color: black;
  margin-left: 30px;
}
.sort .right {
  color: #5e5e5e;
  margin-left: auto;
  margin-right: 0;
}

@media screen and (max-width: 500px) {
  .sort {
    margin: 0 auto;
  }

  .sort .sort-list {
    width: 100%;
  }
}
</style>